module.exports = __webpack_public_path__ + "static/media/survey.5a737ea8.jpg";